import React from 'react';

import { Box, Flex, Image, Text } from '@opendoor/bricks/core';

interface IHeaderProps {
  bathrooms?: number;
  bedrooms?: number;
  photo?: string;
  street?: string;
  sqft?: number;
  show: boolean;
}

/**
 * Showing request creation header
 *
 * storybook-check-ignore
 */
export const Header: React.FC<IHeaderProps> = ({
  bathrooms,
  bedrooms,
  photo,
  show,
  street,
  sqft,
}: IHeaderProps) => {
  if (!show) {
    return null;
  }

  return (
    <Box
      my={[2, null, 5]}
      mx={[0, null, 5]}
      py={[2, null, 5]}
      px={[0, null, 5]}
      width="90%"
      mb={[3, null, 7]}
    >
      <Flex flexDirection="row">
        <Image
          alt="Property"
          height="56px"
          width="56px"
          src={photo}
          objectFit="cover"
          borderRadius="semiRounded"
          ml={[0, null, 7]}
        />
        <Flex flexDirection="column" ml={5}>
          <Text fontWeight="semibold" size="s0">
            {street}
          </Text>
          <Text size="s0">
            {bedrooms} bd {bathrooms} ba, {sqft} sqft.{' '}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};
